import { createFileRoute } from "@tanstack/react-router";

import { NewThreadContainer } from "@/features/app-support/containers/new-thread-container";

export const Route = createFileRoute("/settings/support/new")({
  component: NewThreadContainer,
});
